import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IntegrationMaintenance } from 'src/app/models/integration-maintenance';
import { IntegrationMaintenanceFilters } from 'src/app/models/integration-maintenance-filters';
import { LTHttpUtility } from '../utilities/http-Utility';
import { protectedResources } from '../auth-config';
import { ToastService } from './toast.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class IntegrationMaintenanceService {
  private baseUrl: string = protectedResources.LOSTalkerAPI.endpoint;
  private actionUrl = '';
  private Url = '';
  private headers = new HttpHeaders();

  private errorHandler(error: HttpErrorResponse, ts: ToastService): Observable<any> {
    ts.toastCreate('An HTTP transport error occured: ' + error.url + ' ' + error.status, 'Warning', {
      keepAfterRouteChange: true,
    });

    if (environment.enableDebuggingTools) {
      console.error('An HTTP transport error occured: ' + error.error);
    }

    return throwError(() => error);
  }

  constructor(private http: HttpClient, private toastService: ToastService) { }

  //--------------------------- IntegrationMaintenance ------------------------------------------//

  getAllMaintenances(): Observable<IntegrationMaintenance[]> {
    this.actionUrl = 'IntegrationMaintenances';
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .get<IntegrationMaintenance[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getAllActiveMaintenances(): Observable<IntegrationMaintenance[]> {
    this.actionUrl = 'IntegrationMaintenances/active';
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .get<IntegrationMaintenance[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getUpcomingMaintenances(minDate: Date): Observable<IntegrationMaintenance[]> {
    this.actionUrl = 'IntegrationMaintenances/upcoming';
    this.Url = this.baseUrl.concat(this.actionUrl);
    const params = LTHttpUtility.formatParams(minDate);
    return this.http
      .get<IntegrationMaintenance[]>(this.Url, { params: params })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getMaintenancesByFilter(filters: IntegrationMaintenanceFilters): Observable<IntegrationMaintenance[]> {
    this.actionUrl = 'IntegrationMaintenances/filters';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .post<IntegrationMaintenance[]>(this.Url, filters, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getMaintenance(id: string): Observable<IntegrationMaintenance> {
    this.actionUrl = 'IntegrationMaintenance/';
    this.Url = this.baseUrl.concat(this.actionUrl, id);

    return this.http
      .get<IntegrationMaintenance[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  insertMaintenance(maintenance: IntegrationMaintenance): Observable<string> {
    this.actionUrl = 'IntegrationMaintenance';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .post<string>(this.Url, maintenance, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  updateMaintenance(maintenance: IntegrationMaintenance): Observable<any> {
    this.actionUrl = 'IntegrationMaintenance';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .put(this.Url, maintenance, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  deleteMaintenance(id: string): Observable<any> {
    this.actionUrl = 'IntegrationMaintenance/';
    this.Url = this.baseUrl.concat(this.actionUrl, id);

    return this.http
      .delete(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }
}
